<template>
  <div class="max-w-7xl mx-auto mt-8 bg-white p-6 rounded-xl shadow-md">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-2xl font-bold text-gray-800 flex items-center gap-2">
        Sessions
        <BaseInfoIcon :text="ERKLAERUNG.sessionListe" label="Sessions" />
      </h2>
      <router-link to="/sessions/create">
        <BaseButton class="bg-green-500 hover:bg-green-600">
          Create Session
        </BaseButton>
      </router-link>
    </div>

    <div
      v-if="deleteError"
      class="mb-4 rounded border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800"
      role="alert"
    >
      {{ deleteError }}
    </div>

    <!-- Session list -->
    <ul class="divide-y divide-gray-200">
      <li
        v-for="session in sessions"
        :key="session.id"
        class="py-4 flex items-center justify-between"
      >
        <div>
          <p
            class="text-lg font-medium text-gray-900 cursor-pointer hover:underline"
            @click="$router.push(`/sessions/edit/${session.id}`)"
          >
            {{ session.title }}
          </p>
          <p class="text-gray-500 text-sm">{{ session.description }}</p>
        </div>

        <!-- Actions -->
        <div class="flex items-center space-x-2">
          <BaseButton
            @click="$router.push(`/sessions/edit/${session.id}`)"
            class="p-2 rounded-full"
            variant="edit"
            tooltip="Edit session"
          >
            <PencilIcon class="h-5 w-5" />
          </BaseButton>

          <BaseButton
            @click="confirmDelete(session.id)"
            class="p-2 rounded-full"
            variant="delete"
            tooltip="Delete session"
          >
            <TrashIcon class="h-5 w-5" />
          </BaseButton>
        </div>
      </li>
    </ul>

    <!-- Empty state -->
    <p v-if="!sessions.length" class="text-gray-500 mt-4 text-center">
      No sessions found.
    </p>

    <!-- Confirm Modal -->
    <DeletionConfirmationModal
      :isOpen="showDeleteModal"
      title="Delete Session"
      message="Are you sure you want to delete this session?"
      @confirm="deleteConfirmed"
      @cancel="showDeleteModal = false"
    />
  </div>
</template>

<script>
import { getSessions, deleteSession } from "@/live-sessions/api/sessions";
import { PencilIcon, TrashIcon } from "@heroicons/vue/24/solid";
import BaseButton from "@/BaseComponents/BaseButton.vue";
import BaseInfoIcon from "@/BaseComponents/BaseInfoIcon.vue";
import ConfirmModal from "@/BaseComponents/ConfirmModal.vue";
import { ERKLAERUNG } from "@/async-sessions/erklaerungen";

export default {
  components: {
    PencilIcon,
    TrashIcon,
    BaseButton,
    BaseInfoIcon,
    DeletionConfirmationModal: ConfirmModal,
  },
  data() {
    return {
      ERKLAERUNG,
      sessions: [],
      showDeleteModal: false,
      sessionToDelete: null,
      deleteError: "",
    };
  },
  methods: {
    async fetchSessions() {
      const res = await getSessions();
      this.sessions = res.data;
    },
    confirmDelete(id) {
      this.deleteError = "";
      this.sessionToDelete = id;
      this.showDeleteModal = true;
    },
    async deleteConfirmed() {
      const sessionId = this.sessionToDelete;
      if (sessionId) {
        try {
          await deleteSession(sessionId);
        } catch (err) {
          const detail = err?.response?.data?.detail;
          const reason = typeof detail === "string"
            ? detail
            : detail
              ? JSON.stringify(detail)
              : err?.message || "Unknown error";
          this.deleteError = `Could not delete session ${sessionId}: ${reason}`;
          this.showDeleteModal = false;
          this.sessionToDelete = null;
          return;
        }

        this.showDeleteModal = false;
        this.sessionToDelete = null;
        this.fetchSessions();
      }
    },
  },
  mounted() {
    this.fetchSessions();
  },
};
</script>
